import { ReplaySubject } from 'rxjs';
import { filter } from 'rxjs/operators';
const eventBus$ = new ReplaySubject(1, 3000);
export const sendOnboardingEvent = (key, payload) => {
    eventBus$.next({ key, payload });
};
export const listenToOnboardingEvent = (key) => {
    return eventBus$
        .asObservable()
        .pipe(filter((event) => event.key === key));
};
export const listenToAllOnboardingEvents = () => {
    return eventBus$.asObservable();
};
//# sourceMappingURL=event-bus.js.map